import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

import type { TrackingSite } from './utils';
import { extractSiteGroupingProps } from './utils';

/**
 * Track the attempt to verify the tracking code installation
 *
 * @param data {object} Additional data properties we want to send with the event.
 */
export const trackingCodeVerificationRequest = (site: TrackingSite): void => {
  if (typeof site !== 'undefined') {
    // Hack: Casting data into a different type to keep Segment happy.
    const data = { ...extractSiteGroupingProps(site) };

    Segment.track('Tracking Code Verification Request', data);
  }
};
